import './PlayerAvatar.css';

export const AVATAR_COLORS = ['blue', 'red', 'green', 'purple', 'orange', 'cyan', 'gold', 'dark'] as const;
export type AvatarColor = typeof AVATAR_COLORS[number];

interface PlayerAvatarProps {
  name: string;
  avatarColor: string;
  size?: 'sm' | 'md' | 'lg';
}

export function PlayerAvatar({ name, avatarColor, size = 'md' }: PlayerAvatarProps) {
  const initial = name.slice(0, 1).toUpperCase();
  return (
    <div
      className={`player-avatar player-avatar--${avatarColor} player-avatar--${size}`}
      aria-hidden
    >
      {initial}
    </div>
  );
}
